import { Component, OnInit, Input, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit, EmbeddedViewRef } from '@angular/core';
import { DVFormGroup, DVFormControl } from '../dynamic-validator';

@Component({
  selector: 'app-dv-input-wrapper',
  templateUrl: './dv-input-wrapper.component.html',
  styleUrls: ['./dv-input-wrapper.component.css']
})
export class DvInputWrapperComponent implements OnInit, AfterViewInit {

  @Input() parentFormGroup: DVFormGroup;
  @Input() fieldName: string;
  @Input() inputTemplate: TemplateRef<any>;

  @ViewChild('container', {static: true, read: ViewContainerRef}) container: ViewContainerRef;

  private _embeddedViewRef: EmbeddedViewRef<any>;
  private _nativeInputElm: HTMLElement;

  ngOnInit() {
    this._embeddedViewRef = this.container.createEmbeddedView(this.inputTemplate);
    this._nativeInputElm = this._embeddedViewRef.rootNodes[0] as HTMLElement;

  }

  ngAfterViewInit() {
    const control = this.parentFormGroup.controls[this.fieldName];
    if (control instanceof DVFormControl) {
      control.statusChanges$.subscribe(status => {
        if (control.invalid) {
          this._nativeInputElm.classList.add('border-danger');
        } else {
          this._nativeInputElm.classList.remove('border-danger');
        }
      });
    }
  }

}
